import { NavLink } from 'react-router-dom';

interface SubNavLinkProps {
  to: string;
  label: string | number;
  /** When true, the link will only be active when the URL matches exactly */
  end?: boolean;
}

/**
 * Reusable sub-navigation link component for consistent styling across
 * section navigators (tour events, team stats tabs, etc.)
 * Uses NavLink for automatic active state detection.
 */
export default function SubNavLink({ to, label, end }: SubNavLinkProps) {
  return (
    <NavLink to={to} end={end} className={({ isActive }) => `sub-nav-link ${isActive ? 'active' : ''}`}>
      {label}
    </NavLink>
  );
}
